(function () {
  var LOG = '[WalletProps]';

  function log() {
    try {
      console.log.apply(console, [LOG].concat([].slice.call(arguments)));
    } catch (e) {}
  }

  function warn() {
    try {
      console.warn.apply(console, [LOG].concat([].slice.call(arguments)));
    } catch (e) {}
  }

  function formDataToObject(fd) {
    var out = {};
    if (!fd || typeof fd.entries !== 'function') return out;
    Array.prototype.forEach.call(fd.entries(), function (entry) {
      var key = entry[0];
      var val = entry[1];
      if (typeof File !== 'undefined' && val instanceof File) {
        val = '[File] ' + val.name + ' (' + val.size + 'b)';
      }
      if (Object.prototype.hasOwnProperty.call(out, key)) {
        if (!Array.isArray(out[key])) out[key] = [out[key]];
        out[key].push(val);
      } else {
        out[key] = val;
      }
    });
    return out;
  }

  function init(root) {
    if (!root || root.dataset.walletPdpInit === 'true') return;
    root.dataset.walletPdpInit = 'true';

    const form = root.querySelector('form[data-type="add-to-cart-form"]') || root.querySelector('form.form');
    const variantInputs = root.querySelectorAll('[data-wallet-option]');
    const mainImg = root.querySelector('[id^="main-img-"]');
    const thumbs = root.querySelectorAll('[data-wallet-thumb]');
    const variantIdInput = root.querySelector('[data-wallet-variant-id]');
    const priceEl = root.querySelector('[data-wallet-price]');
    const subEl = root.querySelector('[data-wallet-side-sub]');
    const optionProp = root.querySelector('[data-wallet-option-property]');

    const fontSection = root.querySelector('[data-wallet-font-section]');
    const textSection = root.querySelector('[data-wallet-text-section]');
    const fontInputs = root.querySelectorAll('[data-wallet-font-opt]');
    const textArea = root.querySelector('[data-wallet-textarea]');
    const textCounter = root.querySelector('[data-wallet-text-counter]');
    const fontProperty = root.querySelector('[data-wallet-font-property]');
    const textProperty = root.querySelector('[data-wallet-text-property]');

    const notes = root.querySelector('[data-wallet-notes]');
    const notesCounter = root.querySelector('[data-wallet-notes-counter]');
    const notesProperty = root.querySelector('[data-wallet-notes-property]');
    const qtyInput = root.querySelector('[data-wallet-qty-input]');
    const qtyDisplay = root.querySelector('[data-wallet-qty-display]');
    const qtyMinus = root.querySelector('[data-wallet-qty-minus]');
    const qtyPlus = root.querySelector('[data-wallet-qty-plus]');
    const wishlistBtn = root.querySelector('[data-wallet-wishlist-btn]');
    const wishlistIcon = root.querySelector('[data-wallet-wishlist-icon]');
    const wishlistLabel = root.querySelector('[data-wallet-wishlist-label]');
    const defaultWishlistLabel = (wishlistLabel?.textContent || 'Save for later').trim();

    const wishlistStorageKey = 'etchfyWishlistProducts';
    const productId = String(root.dataset.walletProductId || '');
    const productHandle = root.dataset.walletProductHandle || '';
    const productTitle = root.dataset.walletProductTitle || '';
    const productUrl = root.dataset.walletProductUrl || '';
    const productImage = root.dataset.walletProductImage || '';

    let textModeEnabled = false;

    log('init', {
      productId: productId,
      hasForm: !!form,
      formId: form && form.id,
      fontProperty: !!fontProperty,
      textProperty: !!textProperty,
      notesProperty: !!notesProperty,
      optis: !!(window.BSS_PO || document.querySelector('.po-atc-btn, [po-btn-atc], .po-dropzone')),
      variantCount: variantInputs.length
    });

    function updateNotes() {
      if (!notes || !notesCounter || !notesProperty) return;
      const value = notes.value.trim();
      notesCounter.textContent = `${notes.value.length} / 250`;
      if (value) {
        notesProperty.value = value;
        notesProperty.disabled = false;
      } else {
        notesProperty.value = '';
        notesProperty.disabled = true;
      }
    }

    function updateTextCounter() {
      if (!textArea || !textCounter) return;
      textCounter.textContent = `${textArea.value.length} / 180`;
    }

    function getSelectedFont() {
      const checked = root.querySelector('[data-wallet-font-opt]:checked');
      return checked ? checked.value : 'Classic serif';
    }

    function snapshotProps(label) {
      var allProps = form
        ? Array.prototype.map.call(form.querySelectorAll('[name^="properties["]'), function (el) {
            return {
              name: el.name,
              value: String(el.value || '').slice(0, 80),
              disabled: !!el.disabled,
              type: el.type || el.tagName
            };
          })
        : [];
      log('snapshot (' + label + ')', {
        textModeEnabled: textModeEnabled,
        uiFont: getSelectedFont(),
        uiText: textArea ? String(textArea.value).slice(0, 80) : null,
        uiNotes: notes ? String(notes.value).slice(0, 80) : null,
        fontProp: fontProperty
          ? { value: fontProperty.value, disabled: fontProperty.disabled }
          : null,
        textProp: textProperty
          ? { value: String(textProperty.value).slice(0, 80), disabled: textProperty.disabled }
          : null,
        notesProp: notesProperty
          ? { value: String(notesProperty.value).slice(0, 80), disabled: notesProperty.disabled }
          : null,
        optionProp: optionProp
          ? { value: optionProp.value, disabled: optionProp.disabled }
          : null,
        variantId: variantIdInput ? variantIdInput.value : null,
        allPropertiesInForm: allProps,
        formDataWouldSend: form ? formDataToObject(new FormData(form)) : null
      });
    }

    /**
     * Sync UI → line-item properties. Hidden inputs are what Shopify/Optis submit;
     * disabled fields are omitted from FormData, so we only enable them in text mode.
     */
    function syncPersonalisationProperties(reason) {
      updateNotes();
      updateTextCounter();

      if (!textModeEnabled) {
        if (fontProperty) {
          fontProperty.value = '';
          fontProperty.disabled = true;
        }
        if (textProperty) {
          textProperty.value = '';
          textProperty.disabled = true;
        }
        log('sync (' + (reason || 'n/a') + ') — text mode OFF, cleared Font/Text props');
        snapshotProps('after-sync-off:' + (reason || ''));
        return;
      }

      const fontValue = getSelectedFont();
      const textValue = textArea ? textArea.value.trim() : '';

      if (fontProperty) {
        fontProperty.value = fontValue;
        fontProperty.disabled = false;
      }
      if (textProperty) {
        if (textValue) {
          textProperty.value = textValue;
          textProperty.disabled = false;
        } else {
          textProperty.value = '';
          textProperty.disabled = true;
        }
      }
      log('sync (' + (reason || 'n/a') + ') — text mode ON', {
        font: fontValue,
        textLen: textValue.length,
        textPreview: textValue.slice(0, 60),
        notesEnabled: notesProperty ? !notesProperty.disabled : null
      });
      snapshotProps('after-sync-on:' + (reason || ''));
    }

    function setTextMode(enabled) {
      textModeEnabled = !!enabled;
      if (fontSection) fontSection.classList.toggle('show', textModeEnabled);
      if (textSection) textSection.classList.toggle('show', textModeEnabled);

      fontInputs.forEach((input) => {
        input.disabled = !textModeEnabled;
      });
      if (textArea) {
        textArea.disabled = !textModeEnabled;
        if (!textModeEnabled) textArea.value = '';
      }
      log('setTextMode', {
        enabled: textModeEnabled,
        fontSectionVisible: fontSection ? fontSection.classList.contains('show') : null,
        textSectionVisible: textSection ? textSection.classList.contains('show') : null
      });
      syncPersonalisationProperties('setTextMode');
    }

    function detectMode(input) {
      if (!input) return 'single';
      const attr = (input.dataset.walletMode || '').toLowerCase();
      if (attr === 'double-text' || attr === 'double-photo' || attr === 'single') return attr;

      const title = (input.dataset.walletTitle || input.value || '').toLowerCase();
      if (
        title.includes('photo & text') ||
        title.includes('photo and text') ||
        title.includes('photo + text') ||
        title.includes('photo+text') ||
        (title.includes('photo') && title.includes('text'))
      ) {
        return 'double-text';
      }
      if (
        title.includes('both sides') ||
        title.includes('photo both') ||
        title.includes('two photo') ||
        title.includes('double')
      ) {
        return 'double-photo';
      }
      return 'single';
    }

    function applyVariant(input) {
      if (!input) return;
      const mode = detectMode(input);
      const price = input.dataset.walletPrice || '';
      const title = input.dataset.walletTitle || '';

      log('applyVariant', {
        mode: mode,
        title: title,
        variantId: input.value,
        dataMode: input.dataset.walletMode
      });

      if (variantIdInput) variantIdInput.value = input.value;
      if (priceEl) priceEl.textContent = price;
      // Keep Option disabled — Optis "Choose your option" already covers this in cart
      if (optionProp) {
        optionProp.value = title;
        optionProp.disabled = true;
      }

      if (subEl) {
        if (mode === 'double-photo') subEl.textContent = 'Double sided — two photos selected';
        else if (mode === 'double-text') subEl.textContent = 'Double sided — photo & text selected';
        else subEl.textContent = 'Single sided selected';
      }

      setTextMode(mode === 'double-text');
    }

    variantInputs.forEach((input) => {
      input.addEventListener('change', () => applyVariant(input));
    });

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        thumbs.forEach((item) => item.classList.remove('active'));
        thumb.classList.add('active');
        if (!mainImg) return;
        const src = thumb.dataset.walletFull;
        const alt = thumb.dataset.walletAlt || '';
        if (src) mainImg.src = src;
        mainImg.alt = alt;
      });
    });

    notes?.addEventListener('input', () => {
      updateNotes();
      syncPersonalisationProperties('notes-input');
    });
    textArea?.addEventListener('input', () => {
      updateTextCounter();
      syncPersonalisationProperties('text-input');
    });
    fontInputs.forEach((input) => {
      input.addEventListener('change', () => syncPersonalisationProperties('font-change'));
    });

    function syncQty() {
      if (!qtyInput || !qtyDisplay) return;
      let qty = parseInt(qtyInput.value || '1', 10);
      if (Number.isNaN(qty) || qty < 1) qty = 1;
      qtyInput.value = String(qty);
      qtyDisplay.textContent = String(qty);
    }

    qtyMinus?.addEventListener('click', () => {
      if (!qtyInput) return;
      const qty = parseInt(qtyInput.value || '1', 10) - 1;
      qtyInput.value = String(Math.max(1, qty));
      syncQty();
    });

    qtyPlus?.addEventListener('click', () => {
      if (!qtyInput) return;
      const qty = parseInt(qtyInput.value || '1', 10) + 1;
      qtyInput.value = String(Math.max(1, qty));
      syncQty();
    });

    function getWishlistItems() {
      try {
        const parsed = JSON.parse(localStorage.getItem(wishlistStorageKey) || '[]');
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        return [];
      }
    }

    function setWishlistItems(items) {
      localStorage.setItem(wishlistStorageKey, JSON.stringify(items));
    }

    function isWishlisted(items) {
      return items.some((item) => String(item.id) === productId);
    }

    function renderWishlistState(saved) {
      if (!wishlistBtn) return;
      wishlistBtn.classList.toggle('is-active', saved);
      wishlistBtn.setAttribute('aria-pressed', saved ? 'true' : 'false');
      if (wishlistIcon) wishlistIcon.textContent = saved ? '♥' : '♡';
      if (wishlistLabel) wishlistLabel.textContent = saved ? 'Saved' : defaultWishlistLabel;
    }

    wishlistBtn?.addEventListener('click', () => {
      if (!productId) return;
      const items = getWishlistItems();
      const saved = isWishlisted(items);

      if (saved) {
        setWishlistItems(items.filter((item) => String(item.id) !== productId));
        renderWishlistState(false);
      } else {
        items.push({
          id: productId,
          handle: productHandle,
          title: productTitle,
          url: productUrl,
          image: productImage
        });
        setWishlistItems(items);
        renderWishlistState(true);
      }
    });

    function getPropsForCart() {
      syncPersonalisationProperties('getPropsForCart');
      var props = {};
      // Do not send properties[Option] — Optis already adds "Choose your option"
      if (textModeEnabled) {
        props.Font = getSelectedFont();
        var t = textArea ? textArea.value.trim() : '';
        if (t) props['Personalised text'] = t;
      }
      if (notes && notes.value.trim()) {
        props['Order notes'] = notes.value.trim();
      }
      return props;
    }

    function injectPropsIntoFormData(fd) {
      var props = getPropsForCart();
      Object.keys(props).forEach(function (key) {
        var field = 'properties[' + key + ']';
        // FormData: delete existing then append so we win over empty/stale values
        if (typeof fd.delete === 'function') fd.delete(field);
        fd.append(field, props[key]);
        log('inject FormData', field, String(props[key]).slice(0, 80));
      });
      return props;
    }

    function mergeHeaders(existing, extra) {
      var out = {};
      if (existing && typeof Headers !== 'undefined' && existing instanceof Headers) {
        existing.forEach(function (value, key) {
          out[key] = value;
        });
      } else if (existing && typeof existing === 'object') {
        Object.keys(existing).forEach(function (key) {
          out[key] = existing[key];
        });
      }
      Object.keys(extra || {}).forEach(function (key) {
        out[key] = extra[key];
      });
      return out;
    }

    function injectPropsIntoJsonPayload(parsed, props) {
      // Optis: { items: [{ properties: { photo... } }] } — root properties are ignored
      if (Array.isArray(parsed.items) && parsed.items.length) {
        parsed.items.forEach(function (item, index) {
          item.properties = Object.assign({}, item.properties || {}, props);
          log('merged props into items[' + index + '].properties', item.properties);
        });
        if (parsed.properties) delete parsed.properties;
      } else {
        parsed.properties = Object.assign({}, parsed.properties || {}, props);
        log('merged props into root properties', parsed.properties);
      }
      return parsed;
    }

    function injectIntoCartAddBody(body, props) {
      if (!body) return { body: body, handled: false };

      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        log('body FormData BEFORE inject', formDataToObject(body));
        Object.keys(props).forEach(function (key) {
          var field = 'properties[' + key + ']';
          if (typeof body.delete === 'function') body.delete(field);
          body.append(field, props[key]);
        });
        log('body FormData AFTER inject', formDataToObject(body));
        return { body: body, handled: true };
      }

      if (typeof body === 'string') {
        log('body string — JSON/merge', body.slice(0, 400));
        try {
          var parsed = injectPropsIntoJsonPayload(JSON.parse(body), props);
          var next = JSON.stringify(parsed);
          log('body JSON AFTER inject', parsed);
          return { body: next, handled: true, json: true };
        } catch (e) {
          var params = new URLSearchParams(body);
          Object.keys(props).forEach(function (key) {
            params.set('properties[' + key + ']', props[key]);
          });
          log('body URLSearchParams AFTER inject', Object.fromEntries(params.entries()));
          return { body: params.toString(), handled: true };
        }
      }

      return { body: body, handled: false };
    }

    // Patch fetch so Optis /cart/add.js JSON (items[].properties) also gets Font / text / notes.
    // We do not edit the Optis app — we merge into the request it already built.
    function bindFetchInterceptor() {
      var underlying = window.fetch;
      if (typeof underlying !== 'function') return;

      // Stay outermost: if Optis wraps fetch later, re-install wraps the new fetch.
      if (window.__walletPropsFetchPatched === underlying) return;

      window.fetch = function (input, init) {
        try {
          var url = '';
          var method = (init && init.method) || 'GET';
          var body = init && init.body;

          if (typeof input === 'string') {
            url = input;
          } else if (input && typeof Request !== 'undefined' && input instanceof Request) {
            url = input.url;
            method = init && init.method ? init.method : input.method;
            if (body == null) body = input.body;
          } else if (input && input.url) {
            url = input.url;
          }

          var isCartAdd = /\/cart\/add(\.js)?(\?|$)/i.test(url);

          if (isCartAdd && String(method).toUpperCase() !== 'GET') {
            log('fetch cart/add intercepted', url, method);
            syncPersonalisationProperties('fetch-cart-add');
            var props = getPropsForCart();
            log('theme props to merge into Optis request', props);

            init = Object.assign({}, init || {});

            // Request object with locked body — clone into a fresh init we can rewrite
            if (
              body == null &&
              input &&
              typeof Request !== 'undefined' &&
              input instanceof Request
            ) {
              // body may be consumed; Optis normally passes init.body as string
              body = init.body;
            }

            if (body != null) {
              var injected = injectIntoCartAddBody(body, props);
              if (injected.handled) {
                init.body = injected.body;
                if (injected.json) {
                  init.headers = mergeHeaders(init.headers || (input && input.headers), {
                    'Content-Type': 'application/json'
                  });
                }
              }
            } else if (form) {
              var fd = new FormData(form);
              injectPropsIntoFormData(fd);
              init.method = init.method || 'POST';
              init.body = fd;
              log('fetch built FormData from theme form', formDataToObject(fd));
            }

            try {
              sessionStorage.setItem('walletLastProps', JSON.stringify(props));
            } catch (e) {}

            return underlying.call(this, url || input, init);
          }
        } catch (err) {
          console.error(LOG, 'fetch patch error', err);
        }
        return underlying.call(this, input, init);
      };

      window.__walletPropsFetchPatched = window.fetch;
      window.__walletPropsFetchUnderlying = underlying;
      log('fetch interceptor installed for /cart/add (Optis items[].properties merge)');
    }

    function bindXhrInterceptor() {
      if (window.__walletPropsXhrPatched) return;
      window.__walletPropsXhrPatched = true;
      var XHR = window.XMLHttpRequest;
      if (!XHR || !XHR.prototype) return;
      var open = XHR.prototype.open;
      var send = XHR.prototype.send;

      XHR.prototype.open = function (method, url) {
        this.__walletCartAdd = /\/cart\/add(\.js)?(\?|$)/i.test(String(url || ''));
        this.__walletMethod = method;
        return open.apply(this, arguments);
      };

      XHR.prototype.send = function (body) {
        try {
          if (this.__walletCartAdd && String(this.__walletMethod || '').toUpperCase() !== 'GET') {
            log('XHR cart/add intercepted');
            syncPersonalisationProperties('xhr-cart-add');
            var props = getPropsForCart();
            var injected = injectIntoCartAddBody(body, props);
            if (injected.handled) body = injected.body;
          }
        } catch (err) {
          console.error(LOG, 'xhr patch error', err);
        }
        return send.call(this, body);
      };
      log('XHR interceptor installed for /cart/add');
    }

    function bindCartSync() {
      if (!form) {
        warn('no product form found — cannot bind cart sync');
        return;
      }

      form.addEventListener(
        'submit',
        function (event) {
          log('form submit event', { defaultPrevented: event.defaultPrevented });
          syncPersonalisationProperties('form-submit');
          snapshotProps('form-submit');
        },
        true
      );

      root.addEventListener(
        'click',
        function (event) {
          var btn = event.target.closest(
            'button[name="add"], button.product-form__submit, button.btn-atc, button.po-atc-btn, [po-btn-atc], [data-wallet-paypal-fallback]'
          );
          if (!btn || !root.contains(btn)) return;
          // Re-wrap fetch so we stay outside Optis if it patched after us
          bindFetchInterceptor();
          log('ATC click', {
            tag: btn.tagName,
            className: btn.className,
            name: btn.getAttribute('name'),
            isOptis: !!(btn.classList.contains('po-atc-btn') || btn.hasAttribute('po-btn-atc'))
          });
          syncPersonalisationProperties('atc-click');
          snapshotProps('atc-click');
        },
        true
      );
    }

    bindFetchInterceptor();
    bindXhrInterceptor();
    // Optis often loads after our defer script — re-wrap once DOM is ready + shortly after
    setTimeout(bindFetchInterceptor, 0);
    setTimeout(bindFetchInterceptor, 1500);
    bindCartSync();

    const checked = root.querySelector('[data-wallet-option]:checked');
    applyVariant(checked || variantInputs[0]);
    updateNotes();
    updateTextCounter();
    syncQty();
    renderWishlistState(isWishlisted(getWishlistItems()));
    snapshotProps('boot');

    window.__walletPropsDebug = function () {
      syncPersonalisationProperties('manual-debug');
      snapshotProps('manual-debug');
      log('Tip: submit ATC and watch for "fetch cart/add intercepted"');
      return getPropsForCart();
    };
    log('Tip: run window.__walletPropsDebug() anytime');
  }

  document.querySelectorAll('[data-wallet-card-pdp]').forEach(init);
})();
